export const formatDateTime = (dateString: string, hideTime?: boolean) => {
  const date = new Date(dateString);

  // Format the date
  const formattedDate = date.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  // Format the time
  const formattedTime = date.toLocaleTimeString("th-TH", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  if (hideTime) {
    return formattedDate;
  }
  // Combine date and time
  return `${formattedDate} ${formattedTime}`;
};
